import React from "react";
import { Container, Alert } from "@mui/material";

const SubscriptionError = ({ message }) => (
  <Container maxWidth="lg" sx={{ py: 4 }}>
    <Alert severity="error">{message}</Alert>
  </Container>
);

export default SubscriptionError;
